module.exports = {"zh-CN":{"sysName":"DTC后台管理系统"},"en":{"sysName":"DTC System"}}


//////////////////
// WEBPACK FOOTER
// ./src/utils/lan.json
// module id = zdpn
// module chunks = 1